export default {
    methods: {
        hasSlot(slot) {
            return typeof this.$slots[slot] !== "undefined";
        }
    }
}